import { EMAIL_REGEX } from './regexes';

export const emailFormatCheck = (email: string) => {
  return EMAIL_REGEX.test(email.trim()) && email.length !== 0;
};
